import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import { RouteError404 } from "./404.js";
import { RouteContent } from "./content.js";
import { ForbiddenPage } from "./forbidden.js";
import { RouteRealCommerceContent } from "./real-commerce/content.js";
import { RouteRealCookieBannerContent } from "./real-cookie-banner/content.js";
import { Layout } from "../layout/layout.js";
import { MediaManager } from "./real-cookie-banner/media/mediaManager.js";
import { PreRelease } from "./real-cookie-banner/pre-release/pre-release.js";
import { Releases } from "./real-cookie-banner/release/releases.js";
import { Statistics } from "./real-cookie-banner/statistics/statistics.js";
import { ContentBlockerTemplateCreate } from "./real-cookie-banner/template/content-blocker/contentBlockerTemplateCreate.js";
import { ContentBlockerTemplateEdit } from "./real-cookie-banner/template/content-blocker/contentBlockerTemplateEdit.js";
import { ContentBlockerTemplateOverview } from "./real-cookie-banner/template/content-blocker/contentBlockerTemplateOverview.js";
import { ServiceTemplateCreate } from "./real-cookie-banner/template/service/serviceTemplateCreate.js";
import { ServiceTemplateEdit } from "./real-cookie-banner/template/service/serviceTemplateEdit.js";
import { ServiceTemplateOverview } from "./real-cookie-banner/template/service/serviceTemplateOverview.js";
import { Login } from "./real-cookie-banner/user/login.js";
import { RouteRealProductManagerContent } from "./real-product-manager/content.js";
function Router() {
    const router = createBrowserRouter(createRoutesFromElements(/*#__PURE__*/ _jsxs(Route, {
        element: /*#__PURE__*/ _jsx(Layout, {}),
        children: [
            /*#__PURE__*/ _jsx(Route, {
                path: "/",
                element: /*#__PURE__*/ _jsx(RouteContent, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/forbidden",
                element: /*#__PURE__*/ _jsx(ForbiddenPage, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb",
                element: /*#__PURE__*/ _jsx(RouteRealCookieBannerContent, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/login",
                element: /*#__PURE__*/ _jsx(Login, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/statistics",
                element: /*#__PURE__*/ _jsx(Statistics, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/service",
                element: /*#__PURE__*/ _jsx(ServiceTemplateOverview, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/service/create",
                element: /*#__PURE__*/ _jsx(ServiceTemplateCreate, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/service/edit/:identifier",
                element: /*#__PURE__*/ _jsx(ServiceTemplateEdit, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/content-blocker",
                element: /*#__PURE__*/ _jsx(ContentBlockerTemplateOverview, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/content-blocker/create",
                element: /*#__PURE__*/ _jsx(ContentBlockerTemplateCreate, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/content-blocker/edit/:identifier",
                element: /*#__PURE__*/ _jsx(ContentBlockerTemplateEdit, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/media",
                element: /*#__PURE__*/ _jsx(MediaManager, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/pre-release",
                element: /*#__PURE__*/ _jsx(PreRelease, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rcb/releases",
                element: /*#__PURE__*/ _jsx(Releases, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rc",
                element: /*#__PURE__*/ _jsx(RouteRealCommerceContent, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/rpm",
                element: /*#__PURE__*/ _jsx(RouteRealProductManagerContent, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "*",
                element: /*#__PURE__*/ _jsx(RouteError404, {})
            })
        ]
    })));
    return /*#__PURE__*/ _jsx(RouterProvider, {
        router: router
    });
}
export { Router };
